import React from 'react';

import { ExtensionManifest } from '@atlaskit/editor-common/extensions';
import { DiffContent } from '@atlassian/bitkit-diff';

import { CodeSuggestionEditor } from './code-suggestion-editor';

export function getCodeSuggestionsManifest(
  diffLine: DiffContent,
  saveSuggestion: (suggestion: Record<string, string>) => void
): ExtensionManifest {
  return {
    title: 'Suggest Code',
    type: 'com.atlassian.bbc.code-suggestions',
    key: 'codesuggestions',
    description: 'Make a code suggestion',
    icons: {
      '48': () =>
        import('@atlaskit/icon/glyph/editor/code').then(mod => mod.default),
    },
    modules: {
      nodes: {
        'suggestion-node': {
          type: 'extension',
          render: async () => {
            await Promise.resolve();
            return ({ node }) => (
              <CodeSuggestionEditor
                diffLine={diffLine}
                nodeLocalId={node?.localId}
                saveSuggestion={saveSuggestion}
                suggestionText={node?.parameters?.suggestionText}
              />
            );
          },
        },
      },
    },
  };
}
